import React from "react";
import moment from "moment";
import { compose } from "redux";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Typography, ButtonBase } from "@material-ui/core";

import { invokeIfFunction } from "utils/app.util";

const CalendarMonthsSidebar = ({
  year,
  classes,
  onSelectDates,
  numberOfMonths,
  setSelectedRange,
}) => {
  return (
    <Grid container direction="column">
      <Grid
        item
        className={classNames(
          classes.calendarHeader,
          classes.yearMonthContainer,
        )}
      />
      {moment
        .months()
        .slice(0, numberOfMonths)
        .map((month, index) => {
          const startDate = moment({ year, month: index }).startOf("month");
          const endDate = moment({ year, month: index }).endOf("month");

          return (
            <Grid
              item
              key={month}
              zeroMinWidth
              component={onSelectDates ? ButtonBase : undefined}
              className={classNames(
                classes.calendarRow,
                classes.yearMonthContainer,
              )}
              onClick={() =>
                invokeIfFunction(onSelectDates, startDate, endDate, () =>
                  setSelectedRange(null, null),
                )
              }
            >
              <Typography
                noWrap
                color="primary"
                variant="body2"
                className={classes.monthTitle}
              >
                {month}
              </Typography>
            </Grid>
          );
        })}
    </Grid>
  );
};

const styles = theme => ({
  yearMonthContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    boxShadow: `inset 0px 0px 1px 1px ${theme.palette.grey[100]}`,
  },
  calendarRow: {
    height: theme.altus.mediumRow.height,
  },
  calendarHeader: {
    padding: 2,
    height: theme.altus.row.height + 5,
  },
  monthTitle: {
    fontWeight: theme.typography.fontWeightBold,
  },
});

export default compose(
  withStyles(styles),
  React.memo,
)(CalendarMonthsSidebar);
